import { getCouncilConfig } from '../councils';

/** Routes that render the feed and emit planning-updates-loader events. */
export const isPlanningFeedRoute = (url: string): boolean => {
  let path: string;
  try {
    path = new URL(String(url || ''), 'https://www.city-scope.co.uk').pathname;
  } catch {
    return false;
  }
  const [root, council, area, ...remaining] = path.split('/').filter(Boolean);
  if (root !== 'planning-updates' || remaining.length > 0) return false;
  if (!council) return true;
  if (!getCouncilConfig(council)) return false;
  return !area || /^[a-z0-9][a-z0-9-]{1,80}$/i.test(area);
};
